import React, { Fragment, useContext, useState, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function CancelledEnquiries({ cancelledEnquiries, keyword, searchDate }) {
  const { reservationLoading, upcomingEnquiries } = useContext(AppContext);
  const [displayList, setDisplayList] = useState(null);

  const getBaseCancelledList = () => {
    const fromUpcoming =
      Array.isArray(upcomingEnquiries) && upcomingEnquiries.length > 0
        ? upcomingEnquiries.filter(
            (data) =>
              data?.status === "Cancelled" || data?.status === "Rejected"
          )
        : [];

    const fromProp =
      Array.isArray(cancelledEnquiries) && cancelledEnquiries.length > 0
        ? cancelledEnquiries
        : [];

    const merged = [...fromUpcoming, ...fromProp];

    const byId = new Map();
    merged.forEach((item) => {
      if (!item || item.id == null) return;
      byId.set(item.id, item);
    });

    return Array.from(byId.values());
  };

  const applyFilters = (baseList, date, keyword) => {
    if (!Array.isArray(baseList) || baseList.length === 0) return [];

    const now = new Date();

    let filteredData = baseList.filter((data) => {
      if (!data?.bookingTime) return false;
      const bookingDate = new Date(data.bookingTime);
      return bookingDate >= now;
    });

    if (date) {
      const target = new Date(date);
      filteredData = filteredData.filter((data) => {
        const bookingDate = new Date(data.bookingTime);
        return (
          bookingDate.getFullYear() === target.getFullYear() &&
          bookingDate.getMonth() === target.getMonth() &&
          bookingDate.getDate() === target.getDate()
        );
      });
    }

    if (keyword && keyword.trim().length > 0) {
      const lower = keyword.toLowerCase();
      filteredData = filteredData.filter((item) => {
        const name = item.name?.toLowerCase() || "";
        const email = item.email?.toLowerCase() || "";
        const formattedID = item.formattedID?.toLowerCase() || "";
        const phone = item.phone || "";

        return (
          name.includes(lower) ||
          email.includes(lower) ||
          formattedID.includes(lower) ||
          phone.includes(keyword)
        );
      });
    }

    return filteredData;
  };

  useEffect(() => {
    const baseList = getBaseCancelledList();
    const filtered = applyFilters(baseList, searchDate, keyword);
    setDisplayList(filtered);
  }, [upcomingEnquiries, cancelledEnquiries, keyword, searchDate]);

  return (
    <Fragment>
      <EnquiryListPanel
        title="Cancelled reservations"
        items={displayList}
        loading={reservationLoading}
        emptyMessage="No Cancelled Enquiries"
        showStatus
      />
    </Fragment>
  );
}

export default CancelledEnquiries;
